/**
 * cart-add.js
 * カート追加ボタンの制御
 *
 * 本体サイト (mrc-web) の cart-add.js から、lottery で使わない
 * 温度帯チェックとラッピングモーダルを除いたもの。
 *
 * 対象ボタン: .js-cart-add-btn (data-variant-id 必須)
 *   snippets/cart_btn_lottery.liquid が出力する
 */
(() => {
  // ============================================
  // カート追加処理
  // ============================================

  /**
   * Shopify Cart AJAX API でカートに商品を追加する
   * @param {Array<{id: string|number, quantity: number, properties?: Object}>} items
   * @returns {Promise<Object>} 追加後のカートデータ
   */
  const addItemsToCart = async (items) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.description || 'カートへの追加に失敗しました。');
    }
    return response.json();
  };

  // ============================================
  // イベントハンドラー
  // ============================================

  /**
   * .js-cart-add-btn クリック（カートに追加して /cart へ遷移）
   */
  const handleCartAddClick = async (event) => {
    const button = event.target.closest('.js-cart-add-btn');
    if (!button) return;

    event.preventDefault();

    const { variantId } = button.dataset;
    if (!variantId) {
      return;
    }

    button.disabled = true;
    try {
      await addItemsToCart([{ id: variantId, quantity: 1 }]);
      location.href = '/cart';
    } catch (error) {
      alert(error.message || 'カートへの追加に失敗しました。');
      button.disabled = false;
    }
  };

  // ============================================
  // 初期化（defer 読み込みのため DOM は確実に準備済み）
  // ============================================
  document.addEventListener('click', handleCartAddClick);
})();
